import React, { Component } from "react"
import { Line } from "react-chartjs-2"
import "./Index.scss"

const chartOptions = {
    responsive: true, // 设置为 true 的时候可以自适应
    scaleShowLabels: false,
    scaleShowVerticalLines: false,
    scaleShowGridLines: false,
    scaleLineColor: "white",
    fill: false,
}

export default class ReportChart extends Component {

  render() {
    let chartData = this.props.data
    let unitSite = this.props.type
    let baseColor = unitSite.color
    let data = {
      labels: [],
      datasets: [{
        label: unitSite.unit,
        backgroundColor: baseColor[1], // 下部分的填充颜色
        borderColor: baseColor[0],
        pointBackgroundColor: "#fff",
        pointBorderColor: baseColor[0],
        // pointHighlightFill: baseColor[0],
        // pointHighlightStroke: baseColor[1],
        defaultFontSize:8,
        data: [],
      }],
      total: 0
    }

    // 根据 state 的切换对这里的数据处理有一定的变化
    if (chartData && chartData[`${unitSite.name}_charts`]) {
        chartData[`${unitSite.name}_charts`].forEach((item) => {
            data.labels.push(item.time)
            data.datasets[0].data.push(item.value)
        })
    }

    if (chartData && chartData[`total_${unitSite.name}`]) {
      data.total = chartData[`total_${unitSite.name}`]
      if (data.total.toString().indexOf(".") > -1) {
        data.total = data.total.toFixed(2)
      }
    }

    let width = (document.body.clientWidth - 130) * 1/3 * 0.95 // response true的情况下其实并没有生效

    return (
      <div className={`report-chart report-chart-${unitSite.name}`}>
        <div className="report-chart-title">
          <p className="pull-left">
            <span className="report-chart-title-number">
              {data.total}
            </span>
            {unitSite.unit}
          </p>
          <p>
            <span className="chart-sub-tag pull-right"><i /></span>
            <span className="chart-sub-title pull-right">{unitSite.title}</span>
          </p>
        </div>
        <Line data={data} options={chartOptions} height="150" width={width} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/ReportChart/index.js